import { useApp, useBehavior, useList, useTriggerAction } from '@libs/core';
import { TWidgetProps } from '@libs/types';
import React from 'react';
import { TConsumerItem, TConsumerListData } from '../../../types/data';
import { TListOption } from '../../../types/options';
import { CurrencyListView } from './CurrencyListView';

const withSelectedState = (items: Array<TConsumerItem> | undefined, currentValue?: string, isDisabled?: boolean): Array<TConsumerItem> =>
    Array.isArray(items)
        ? items.map((item) => ({
              ...item,
              isDisabled: isDisabled ? true : item.isDisabled,
              selected: item.selected
                  ? true
                  : item.id?.toLowerCase?.() === currentValue?.toLowerCase?.() || (item.value as string)?.toLowerCase?.() === currentValue?.toLowerCase?.(),
          }))
        : [];

export const CurrencyListWidget: React.FC<TWidgetProps<TConsumerListData, TListOption>> = ({ widget }) => {
    const { isHidden, isDisabled } = useBehavior(widget);
    const { setModal, setPopup, setBottomSheet } = useApp();
    const { triggerActionsByType } = useTriggerAction(widget);
    const { handleClick } = useList(widget, { triggerActionsByType, setModal, setPopup, setBottomSheet });

    const items = withSelectedState(widget?.data?.items, widget?.data?.value as string, isDisabled);

    return <CurrencyListView widget={widget} isHidden={isHidden} items={items} onSelectItem={handleClick} />;
};
